import PropTypes from 'prop-types';
import React from 'react';

import {_} from '../../../utils/i18n';

import LessonContainer from './LessonContainer';
import Row from '../../../components/Row';
import Column from '../../../components/Column';
import Button from '../../../components/Button';

/**
 * Renders a message on error.
 */
const LessonError = ({error, onRetry}) => (
    <LessonContainer>
        <div className="card lesson-error">
            <div className="card-content">
                <Row>
                    <Column>
                        <p className="intro">
                            {_('An error occured, please try again.')}
                        </p>
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <p className="error">
                            {String(error)}
                        </p>
                    </Column>
                </Row>
            </div>
            <div className="card-action right-align">
                <Button onClick={onRetry}>
                    {_('Try Again')}
                </Button>
            </div>
        </div>
    </LessonContainer>
);

LessonError.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Error),
    ]).isRequired,
    onRetry: PropTypes.func.isRequired,
};

export default LessonError;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonError.js